const { Keywords } = require('../core/keywords');

/**
 * Supported Escape Characters:
 * \n - Newline
 * \t - Tab
 * \r - Carriage Return
 * \" - Double Quote
 * \' - Single Quote
 * \\ - Backslash
 */

module.exports = {
    [Keywords.PROGRAM_START]: 'नमस्ते {{name}}',
    [Keywords.PROGRAM_END]: 'अलविदा {{name}}',
    [Keywords.PRINT]: 'बोलो {{name}}',
    [Keywords.VARIABLE]: '{{name}} ये है',
    [Keywords.UNTIL]: 'जब तक {{name}}',
    [Keywords.IF]: 'अगर {{name}}',
    [Keywords.ELSE]: 'वरना {{name}}',
    [Keywords.FOR]: 'चक्र {{name}}',
    [Keywords.BREAK]: 'रुको',
    [Keywords.CONTINUE]: 'जारी',
    [Keywords.TRUE]: 'सही',
    [Keywords.FALSE]: 'गलत',
    [Keywords.AND]: 'और',
    [Keywords.OR]: 'या',
    [Keywords.LENGTH]: 'लंबाई',
    [Keywords.INPUT]: 'पूछो {{name}}'
};
